<template>

    <div style="text-align:center;">
			<div class="rptframe">
				<p style="font-size:1.2rem;">个性化定制</p>
				<div style="margin:0 15%;">
                    <div style="margin: 0;font-size:0.8rem;	text-align:left;">
               
                    </div>
                    <div style="margin:12px 0;">
                        <el-input v-model="form.idnumber" placeholder="证件号码" :maxlength="18" style="width:100%;"
                                  onkeypress="return event.charCode!=32">
                        </el-input>
                    </div>
                    <div style="margin:12px 0;">
                        <el-input v-model="form.phone" placeholder="手机号" :maxlength="11" style="width:100%;"
                                  onkeypress="return event.charCode>=48 && event.charCode <=57">
                        </el-input>
                    </div>
					<el-row>
						<el-col :span="12" style="text-align:left;">
							<el-input v-model="form.vcode" placeholder="手机验证码" :maxlength="6" style="width:100%;"
                                  onkeypress="return event.charCode>=48 && event.charCode <=57">
							</el-input>
						</el-col>
						<el-col :span="11" :offset="1">
							<timerbtn ref="tb2" type="primary" :loading="vcloading" @run="sendvcode" style="width:100%;height:36px;margin:0;font-size:13px;">发送</timerbtn>
						</el-col>
					</el-row>

				</div>
                <div style="margin-bottom:0.6rem;">
                    <el-button type="primary" style="width:40%;margin:20px 0"  @click="dologin">登录</el-button>
				</div>
			</div>
		</div>
</template>

<script>
    /* eslint-disable */
    import {restbase} from '../rest'
    import Timerbtn from '@/components/Timerbtn.vue'
    import {foowwLocalStorage} from '../rest'

    export default {
        name: 'login',
        data() {
            return {
                form: {
                    idnumber: '',
                    phone: '',
                    vcode: ''
                },
                vcloading:''
            }
        },
        components: {
            Timerbtn
        },
		methods: {
			sendvcode() {
                this.$http.post(restbase() + "asp/SendVerifyInfo", {
                    SFZH: this.form.idnumber,
                    Phone: this.form.phone
                }).then((response) => {
                    console.log(response);
                    const r = JSON.parse(response.data.d);
                    if (r[0].code !== '0') {
                        this.$notify.error({
                            title: '错误',
                            message: r[0].description
                        });
                    } else {
                        this.$notify({
                            title: '成功',
                            message: '验证码已发送',
                            type: 'success'
                        });
                        this.$refs.tb.start();
                    }
                }, (response) => {
                    console.log(response);
                }).catch((response) => {
                    console.log(response);
                });
			},
            dologin() {
                
                this.$http.post(restbase() + "asp/GetLoginInfo", {
                    PaperValue: this.form.idnumber,
                    Mobile: this.form.phone,
                    PWD: this.form.vcode
                }).then((response) => {
                    const r = JSON.parse(response.data.d);
                    console.log(r);
                    if (r.code !== '0') {
                        this.$notify.error({
                            title: '错误',
                            message: r.description
                        });
                    } else {
                        this.$root.user = r;
                        sessionStorage.clear();
                        foowwLocalStorage.set('user',JSON.stringify(r));
                        this.$router.push('info');
                        //sessionStorage.setItem("user",r);
                    }
                }, (response) => {
                    console.log(response);
                }).catch((response) => {
                    console.log(response);
                });
            }
		}
    }
</script>

<style>
    .loginframe {
        position: relative;
        height: 370px;
        width:500px;
        margin:0 auto;
        border-radius: 4px;
        border-left: 1px solid #ddd;
        box-shadow: 3px 3px 3px #aaa;
        background-color: white;
    }
    .loginhead {
        width:80%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
    }
    .loginform {
        padding: 30px 70px 10px 30px;
    }
</style>